var i = Object.defineProperty;
var t = (o, r, e) => r in o ? i(o, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[r] = e;
var s = (o, r, e) => (t(o, typeof r != "symbol" ? r + "" : r, e), e);
import { MVTLayer as p } from "@deck.gl/geo-layers/typed";
import { CompositeLayer as a } from "@deck.gl/core/typed";
import { PLTradeAreaPolygonGeoJsonLayer as l } from "./index.es426.js";
class h extends a {
  renderLayers() {
    return new p({
      id: `${this.props.id}-mvt`,
      minZoom: 3,
      maxZoom: this.props.maxZoom,
      data: `${this.props.chainTileUrl}/{z}/{x}/{y}.pbf`,
      visible: this.props.visible,
      binary: !0,
      refinementStrategy: "no-overlap",
      loadOptions: {
        fetch: {
          headers: { Authorization: `Token ${this.props.token}` }
        }
      },
      updateTriggers: {
        renderSubLayers: [
          this.props.visible,
          this.props.strokeWidth,
          this.props.strokeColor,
          this.props.fillOpacity,
          this.props.fillColor
        ]
      },
      renderSubLayers: (r) => new l({
        ...r,
        strokeWidth: this.props.strokeWidth,
        strokeColor: this.props.strokeColor,
        basemapType: this.props.basemapType,
        fillOpacity: this.props.fillOpacity,
        fillColor: this.props.fillColor
      })
    });
  }
}
s(h, "layerName", "PLTradeAreaPolygonByChainLayer");
export {
  h as PLTradeAreaPolygonByChainLayer
};
//# sourceMappingURL=index.es480.js.map
